module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/7dbb230934c3502349f0c82096268691.png";